import { Injectable } from "@angular/core";
import { Vector3 } from "three/src/math/Vector3.js";
import * as Three from "three";
import { Debris } from "./primitives/debris";
import { ThreeService } from "../rendering/threejs/three.service";
import {
  selectCameraTarget,
  selectCameraZoomTarget,
} from "../../state/camera/camera.selector";
import { Store } from "@ngrx/store";
import {THREE} from "@angular/cdk/keycodes";
import {GridHelper} from "three";

@Injectable({
  providedIn: "root",
})
export class DebrisService {
  instances: Debris[] = [];
  instanceBins: Debris[][] = [];
  instances1: Debris[] = [];
  instances2: Debris[] = [];
  instances3: Debris[] = [];
  cameraTarget: Vector3 = new Vector3();
  cameraZoom: number = 0;
  debrisBins = 1

  frameCount = 0

  constructor(
    private threeService: ThreeService,
    private store: Store,
  ) {
    this.store.select(selectCameraTarget).subscribe((target) => {
      this.cameraTarget.copy(target);
    });
    this.store.select(selectCameraZoomTarget).subscribe((target) => {
      this.cameraZoom = target;
    });
    for (let i =0; i < this.debrisBins; i++) this.instanceBins.push([]);
  }

  dummy = new Three.Object3D();
  mesh: Three.InstancedMesh;

  async setup(intensity: number) {
    const gridIndices = 3 * intensity;
    const count = Math.pow(gridIndices, 2);
    const width = 40;
    const height = 40;
    const depth = 4000;

    const geometry = new Three.CircleGeometry(0.06, 32)
    // const geometry = new Three.IcosahedronGeometry(0.06, 3);
    const material = new Three.MeshStandardMaterial({ color: 0x252525 });
    // const material = new Three.MeshBasicMaterial( { color: 0x111111 } );
    // const material = new Three.MeshBasicMaterial( { color: 0x111111 } );
    // const material = new Three.MeshDepthMaterial();
    this.mesh = new Three.InstancedMesh(geometry, material, count);
    let counter = 0;

    for (let x = 0; x < gridIndices; x += 1) {
      for (let y = 0; y < gridIndices; y += 1) {
        counter += 1;
        const debris = new Debris(
          new Vector3(
            -(width / 2) + x * (width / gridIndices),
            -(height / 2) + y * (height / gridIndices),
            -((depth / 3) * 4) + Math.random() * depth,
          ),
          counter,
        );
        const bin = Math.floor(Math.random() * this.debrisBins)
        this.instanceBins[bin].push(debris);
        // this.instances.push(debris);
        debris.update(
          this.mesh,
          this.dummy,
          this.cameraTarget,
          this.cameraZoom,
        );
      }
    }

    const size = 100000;
    const divisions = 200;
    const gridHelper = new GridHelper( size, divisions );
    gridHelper.rotation.x = Math.PI / 2;
    this.threeService.addToScene( gridHelper );

    this.threeService.addToScene(this.mesh);
  }

  async update(timeDelta: number) {
    for (let debris of this.instanceBins[this.frameCount]) {
      debris.update(this.mesh, this.dummy, this.cameraTarget, this.cameraZoom);
    }
    this.frameCount += 1;
    if (this.frameCount == this.debrisBins) {
      this.frameCount = 0;
    }
  }
}
